// Author:Walid Birouk
let sliderIndex = 1;
let timeout;
const layers = [...document.querySelectorAll('.layer')];
const covers = [...document.querySelectorAll('.photo-frame')];

function changeCoverAnimState(state = 0) {
    const st = state === 1 ? 'running' : 'paused';
    covers.forEach(cover => {
        // cover.style['animation-play-state'] = st;
        cover.querySelector('.cover').style.width = `${state * 100}%`;
    });
}

function switchLayer(step = 1) {
    const nextSlide = (sliderIndex + step) % 3 === 0 ? 3 : (sliderIndex + step) % 3;

    changeCoverAnimState(1);
    clearTimeout(timeout);
    timeout = setTimeout(() => {
        changeCoverAnimState(0)
    }, 500);

    for(let i of layers) {
        i.classList.remove('layer-displayed');
        i.classList.remove('layer-displayed-exit');
        if(i.dataset.scene == nextSlide) {
            i.classList.add('layer-displayed');
        }
        if(i.dataset.scene == sliderIndex) {
            i.classList.add('layer-displayed-exit');
        }
    }
    sliderIndex = nextSlide;
}



// needed for the mobile version

$('.mob-nav').click(() => {
    $('.mob-links').addClass('open');
});

$(document).click(() => {
    if ($(window).width() < 992) {
        if (!$(event.target).closest('.mob-links,.mob-nav').length) {
            event.preventDefault();
            $('.mob-links').removeClass('open');
        }
    }
});
